import clsx from "clsx";
import { UploadDragRoot } from "./UploadDrag.styles";

export interface UploadDragProps {
    className?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
}

const UploadDrag = ({ className, children, ...rest }: UploadDragProps) => {
    return (
        <UploadDragRoot className={clsx("upload-drag", className)} alignItems="center" justifyContent="center" {...rest}>
            {children}
        </UploadDragRoot>
    );
};

export default UploadDrag;
